const Phone = () => {
    return (
        <a className="phone" href={`tel://${process.env.REACT_APP_PHONE}`} target="_blank" rel="noreferrer">
            <i style={{ marginRight: '2px' }} className="fas fa-phone phone-icon"></i>
        </a>
    )
}

export default Phone;